module.exports = __webpack_public_path__ + "fonts/500-normal-cyrillic-ext.65edd3f.woff2";